import axios from "axios";
import config from "../config";
import { ShareTokenResponse } from "./ResponseModels/ShareTokenResponse";
import { FakeAxiosResponse } from "./FakeAxiosResponse";
import ShareUrlResponseFake from "./json/ShareUrlResponseFake.json";

export async function PostShareModel(imageUuid: string) {
  let response = null;
  if (!config.useFakeModels) {
    response = axios
      .post<ShareTokenResponse>(config.getShareEndpoint, {
        imageUuid: imageUuid,
      })
      .catch((e) => {
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(ShareUrlResponseFake));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
